const subtitle = 'TBC'

export default {
  list: { lazy: () => import('./InventoryLocations'), component: 'InventoryLocationList' },
  create: { lazy: () => import('./InventoryLocations'), component: 'InventoryLocationCreate' },
  edit: { lazy: () => import('./InventoryLocations'), component: 'InventoryLocationEdit' },
  options: {
    create: {
      title: 'Create Location',
      subtitle: subtitle,
      breadCrumb: 'Create Location',
    },
    list: {
      title: 'Locations',
      subtitle: subtitle,
      breadCrumb: 'Locations',
    },
    edit: {
      title: 'Edit Location',
      subtitle: subtitle,
      breadCrumb: 'Edit Location',
    },
  },
}
